__turbopack_context__.v({
  "ambient": "website-ambient-background-module__uaf6PW__ambient",
  "blueDrift": "website-ambient-background-module__uaf6PW__blueDrift",
  "hero": "website-ambient-background-module__uaf6PW__hero",
  "paused": "website-ambient-background-module__uaf6PW__paused",
  "peachDrift": "website-ambient-background-module__uaf6PW__peachDrift",
  "playing": "website-ambient-background-module__uaf6PW__playing",
  "primaryDrift": "website-ambient-background-module__uaf6PW__primaryDrift",
  "ribbon": "website-ambient-background-module__uaf6PW__ribbon",
  "ribbonBlue": "website-ambient-background-module__uaf6PW__ribbonBlue",
  "ribbonPeach": "website-ambient-background-module__uaf6PW__ribbonPeach",
  "ribbonPrimary": "website-ambient-background-module__uaf6PW__ribbonPrimary",
  "soft": "website-ambient-background-module__uaf6PW__soft",
  "wash": "website-ambient-background-module__uaf6PW__wash",
  "workflow": "website-ambient-background-module__uaf6PW__workflow",
});
